export const Lista_Idiomas = [
    'Alemán',
    'Español',
    'Frances',
    'Inglés',
    'Mandarín',
    'Portugués',
    'Ruso',
] as const;